<template>
<div>
    <div role="alert" class="mcc-alert mcc-alert--primary-solid error-msg-div" style="margin-bottom:0px;">
        <div class="mcc-row">
            <div class="mcc-col mcc-col-8 error-msg">
                <p class="error-heading">The application is currently down!</p>
                <p class="error-body">The system seems to be down at the moment. We’re working hard to fix things, so please try again later. </p>
                <button class="mcc-button mcc-button--outline" @click="$router.go(-1)" title="Back">
                    <mcc-icon name="refresh" aria-hidden="true"></mcc-icon><span class="mcc-button__label">Refresh</span>
                </button>
            </div>
            <div class="mcc-col mcc-col-4 error-icon">
                <div class="mcc-filtered-icon__name">
                    <mcc-icon name="sad_cloud" aria-hidden="true" icon-set="fluency-color"></mcc-icon>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import axios from "axios";
import constants from "../constants";

export default {
  name: "ApplicationError",
  data() {
    return {
      interval: null,
    };
  },
  methods: {
    doHealthCheck() {
      axios
        .get(constants.BASE_URL + "/actuator/info", { withCredentials: true })
        .then((response) => {
          if (response.status === 200) {
            if (self.localStorage.getItem("oldURL")) {
              this.$router.push(self.localStorage.getItem("oldURL"));
            } else {
              this.$router.push("/");
            }
          }
        });
    },
  }
};
</script>
<style scoped>
.error-msg-div {
    max-width: 550px;
    margin: auto;
    padding: 25px;
    --mds-alert-accent-border-color: none;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
.error-heading {
    font-size: 18px;
    font-weight: bolder;
    color: var(--mds-button-outline-color, var(--mds-text-color-default, #161616));
}

.error-icon {
    background-color: var(--mds-ui-color-02, #eeeef1);
    border-radius: 15px;
}

.mcc-filtered-icon__name {
    transform: translate(15%, 50%);
}

.mcc-icon {
    --mds-alert-base-icon-fill: var(--mds-button-outline-color, var(--mds-text-color-default, #161616))
}
</style>
